import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { ClosedPeriodModel } from '../models';
import { ClosedPeriodEndpoint } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ClosedPeriodItemService {
  constructor(private http: WrapperHttpService) {}

  getPeriodItem({
    compartmentId,
    dockId,
    closedPeriodId,
  }: {
    compartmentId: number;
    dockId: number;
    closedPeriodId: number;
  }): Observable<ClosedPeriodModel> {
    return this.http.withLoading().get<ClosedPeriodModel>(this.getUrl(compartmentId, dockId, closedPeriodId));
  }

  createPeriodItem({
    compartmentId,
    dockId,
    data,
  }: {
    compartmentId: number;
    dockId: number;
    data: ClosedPeriodModel;
  }): Observable<ClosedPeriodModel> {
    return this.http.withLoading().post<ClosedPeriodModel>(this.getUrl(compartmentId, dockId), data);
  }

  updatePeriodItem({
    compartmentId,
    dockId,
    data,
  }: {
    compartmentId: number;
    dockId: number;
    data: ClosedPeriodModel;
  }): Observable<ClosedPeriodModel> {
    return this.http.withLoading().put<ClosedPeriodModel>(this.getUrl(compartmentId, dockId, data.id), data);
  }

  deletePeriodItem({
    closedPeriodId,
    compartmentId,
    dockId,
  }: {
    closedPeriodId: number;
    compartmentId: number;
    dockId: number;
  }): Observable<ClosedPeriodModel> {
    return this.http.withLoading().delete<ClosedPeriodModel>(this.getUrl(compartmentId, dockId, closedPeriodId));
  }

  private getUrl(compartmentId: number, dockId: number, closedPeriodId?: number): string {
    return !!closedPeriodId
      ? `${API_URL}${ClosedPeriodEndpoint.WorkingTime}${ClosedPeriodEndpoint.Compartment}/${compartmentId}${
          dockId ? ClosedPeriodEndpoint.Dock + '/' + dockId : ''
        }${ClosedPeriodEndpoint.ClosedDays}/${closedPeriodId || ''}`
      : `${API_URL}${ClosedPeriodEndpoint.WorkingTime}${ClosedPeriodEndpoint.Compartment}/${compartmentId}${
          dockId ? ClosedPeriodEndpoint.Dock + '/' + dockId : ''
        }${ClosedPeriodEndpoint.ClosedDays}`;
  }
}
